import { CONTACT, PROFILE, NAV } from "@/data/profile";
import { useLenis } from "@/components/LenisProvider";

export const Footer = () => {
  const lenis = useLenis();
  const go = (e, href) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(href === "#top" ? 0 : href, { offset: -64 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="site-footer" className="section-dark border-t hairline overflow-hidden">
      <div className="grid grid-cols-12 gap-8 px-6 md:px-12 py-16 border-b hairline">
        <div className="col-span-12 md:col-span-5">
          <div className="font-display uppercase text-2xl md:text-3xl leading-none">
            Warden Offshore <span className="text-[var(--accent)]">Engineering</span>
          </div>
          <p className="mt-4 text-sm text-muted max-w-sm">
            {PROFILE.companyTag}. {PROFILE.years} years of offshore drilling, well-control and rig-management expertise, led by {PROFILE.name}.
          </p>
          <div className="mt-6 flex items-center gap-3 eyebrow">
            <span className="live-dot inline-block w-2 h-2 bg-[var(--accent)]" />
            {PROFILE.availability}
          </div>
        </div>
        <div className="col-span-6 md:col-span-3 text-sm space-y-3" data-testid="footer-contact">
          <div className="eyebrow mb-4">Contact</div>
          <a href={`mailto:${CONTACT.email}`} className="block hover:!text-[var(--accent)] transition-colors duration-300">{CONTACT.email}</a>
          <div>{CONTACT.phone}</div>
          <div>WhatsApp {CONTACT.whatsapp}</div>
          {CONTACT.address.map((l) => <div key={l} className="text-muted">{l}</div>)}
        </div>
        <div className="col-span-6 md:col-span-3 md:col-start-10 text-sm space-y-3">
          <div className="eyebrow mb-4">Index</div>
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={(e) => go(e, n.href)} data-testid={`footer-link-${n.label.toLowerCase()}`} className="block hover:!text-[var(--accent)] transition-colors duration-300">
              {n.label}
            </a>
          ))}
        </div>
      </div>
      <div className="px-6 md:px-12 pt-12 pb-8">
        <div className="font-display font-bold uppercase leading-[0.8] text-[clamp(3rem,13vw,13rem)] outline-text select-none">
          Warden
        </div>
        <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 eyebrow">
          <span>© {new Date().getFullYear()} {CONTACT.company} — {PROFILE.name}</span>
          <span>Offshore drilling · well control · rig management</span>
          <a href="#top" onClick={(e) => go(e, "#top")} data-testid="footer-back-to-top" className="hover:!text-[var(--accent)] transition-colors duration-300">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
};
